'use client';

import React, { useState } from 'react';
import { Checkbox, Box, Button, Menu, MenuButton, MenuList, MenuItem } from '@chakra-ui/react';
import { ChevronDownIcon } from '@chakra-ui/icons';

const DynamicColumnFilter = ({ columnsData, columnVisibility, setColumnVisibility }) => {
  const toggleColumn = (columnId) => {
    setColumnVisibility((prev) => ({
      ...prev,
      [columnId]: !prev[columnId],
    }));
  };

  return (
    <Box mb={4}>
      <Menu>
        <MenuButton as={Button} rightIcon={<ChevronDownIcon />} colorScheme="blue">
          Filter Columns
        </MenuButton>
        <MenuList>
          {columnsData.map((column) => (
            <MenuItem key={column.id}>
              <Checkbox
                isChecked={columnVisibility[column.id]}
                onChange={() => toggleColumn(column.id)}
              >
                {column.header}
              </Checkbox>
            </MenuItem>
          ))}
        </MenuList>
      </Menu>
    </Box>
  );
};

export default DynamicColumnFilter;